/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class CustomerOfferViewModel extends JSONable {

  uuid: string | undefined = undefined;

  owner: string | undefined = undefined;

  parentOwner: string | undefined = undefined;

  offerRequestUuid: string | undefined = undefined;

  accepted: string | undefined = undefined;

  serviceProviderUuid: string | undefined = undefined;

  serviceProviderName: string | undefined = undefined;

  currency: string | undefined = undefined;

  priceValue: string | undefined = undefined;

  pickupLocations: string | undefined = undefined;

  deliveryLocations: string | undefined = undefined;

}
